'use client';
import getLocal from 'eco-design-reliance/getLocal';
import dynamic from 'next/dynamic';
import { Fragment, useEffect, useRef, useState } from 'react';
import WidgetsArrowSvgA from '../comps/ArrowSvgA';
import getCurrentEffect from '../utils/getCurrentEffect';
import WidgetsItemBackToTop from '../widgets-items/widgets-item-BackToTop';
import WidgetsItemBackToBottom from '../widgets-items/widgets-item-BackToBottom';
import WidgetsItemEcoCreditsWin from '../widgets-items/widgets-item-EcoCreditsWin';
import EcoCreditsWinEnterA from '../widgets-items/widgets-item-EcoCreditsWin/EcoCreditsWinEnterA';
import WidgetsItemMicrosoftChat from '../widgets-items/widgets-item-MicrosoftChat';
import WidgetsItemQuestionnaire from '../widgets-items/widgets-item-questionnaire';
import useHoverOpen from '../widgets-items/widgets-item-questionnaire/useHoverOpen';
import { openNewWidgetsLocales, OtherLocaleSettingA } from './other-locale-setting';
import EcoCart from 'eco-design/elements/eco-cart';
import EcoCartIcon from 'eco-design/elements/eco-cart/comps/EcoCartIcon';

const QuestionnaireModalDynamic = dynamic(() => import('../widgets-items/widgets-item-questionnaire/Questionnaire'), {
    ssr: false,
});
export default function WidgetsBottomRight({
    __globar_right_v2 = [],
    __globar_bottom_v2 = [],
    globalTimestamp,
}: {
    __globar_right_v2: any[];
    globalTimestamp: number;
    __globar_bottom_v2: any[];
}) {
    const widgetHided = true;
    const [showHiddenBtn, setShowHiddenBtn] = useState<boolean>(false);
    const [showEcoCart, setShowEcoCart] = useState<boolean>(false);
    const [showBackToBottom, setShowBackToBottom] = useState<boolean>(false);
    const [questionnaireCloseOnlyMode, setQuestionnaireCloseOnlyMode] = useState<boolean>(false);
    const [modalPos, setModalPos] = useState<{ modalPosY: number; questionIconH: number }>({ modalPosY: 0, questionIconH: 0 });
    const widgetIn2 = useRef<any>(null);
    const { locale, pathname } = getLocal();
    const isBlogDetailPage = /\/blog\/.+/.test(pathname);

    const static_list_a = OtherLocaleSettingA[locale] || [];
    const __globar_right_list = openNewWidgetsLocales.includes(locale) ? __globar_right_v2 || [] : static_list_a;

    const sortRightList = __globar_right_list.sort((a, b) => b.sort - a.sort);

    const { open, show, hide, immediatelyHide, hasContinue, setHasContinue } = useHoverOpen(100);
    const immediatelyHideQuestionnaire = () => {
        setQuestionnaireCloseOnlyMode(false);
        immediatelyHide();
    };

    useEffect(() => {
        const el = document.getElementById('Widgets-box-in2-right-id');
        if (!el) return;

        const calc = () => {
            const sortRightList2 = sortRightList.filter((item: any) => {
                const flagA1 = item.enable;
                const flagA2 = getCurrentEffect(item, pathname);
                const flagA3 = item.widgetType !== 'SHOPPING_CART';
                return flagA1 && flagA2 && flagA3;
            });
            const count = sortRightList2.length + el.children.length;

            setShowHiddenBtn(count >= 2);
        };

        calc(); // 初始化

        const observer = new MutationObserver(calc);

        observer.observe(el, {
            childList: true,
            subtree: true,
        });
        return () => observer.disconnect();
    }, [sortRightList, pathname]);

    const getDistanceToParentBottom = (el) => {
        const parent = el.offsetParent;
        return parent.clientHeight - (el.offsetTop + el.offsetHeight);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const questionIcon = document.getElementById('WIDGET_Questionnaire');
                if (!questionIcon) {
                    return;
                }
                const distant = getDistanceToParentBottom(questionIcon);
                const arrowAElHeight = (document.querySelector('.widgets-ArrowSvgA') as HTMLElement)?.offsetHeight || 0;
                const questionIconH = distant + 24 + arrowAElHeight;
                const questionModalH = document.getElementById('WIGET_Questionnaire_Modal')?.offsetHeight || 0;
                const modalPosY1 = questionIconH - Math.ceil(questionModalH / 2);
                setModalPos({
                    modalPosY: modalPosY1,
                    questionIconH,
                });
                // const questionParent = document.getElementById('WIDGET_WidgetsBottomRight_Inner');
            }, 300);
        }
    }, []);

    return (
        <section className="WidgetsBottomRight" id="widgetBottomRight">
            <div className="WidgetsBottomRight-inner" id="WIDGET_WidgetsBottomRight_Inner">
                <div className="Widgets-box-in1">
                    <WidgetsItemBackToTop />
                    <div className="Widgets-box-in2" id="Widgets-box-in2-right-id">
                        {isBlogDetailPage && <WidgetsItemBackToBottom />}
                    </div>
                    {/* onPointerEnter={show} onPointerLeave={hide} */}

                    {sortRightList.map((itemA: any, index: number) => {
                        const widgetType = itemA.widgetType || '';
                        const isOpen_MicrosoftChatItemA = widgetType === 'CHAT'; //客服聊天
                        const isOpen_SHOPPING_CART = widgetType === 'SHOPPING_CART'; //购物车
                        const isOpen_MEMBER = widgetType === 'MEMBER'; //会员
                        const isOpen_QUESTIONNAIRE = widgetType === 'QUESTIONNAIRE'; //问卷
                        const bottom_Chat = __globar_bottom_v2?.length > 0 ? __globar_bottom_v2[0] : {};
                        const isOpenBottomChat = bottom_Chat.enable && getCurrentEffect(bottom_Chat, pathname);
                        const isOpenInPathname = openNewWidgetsLocales.includes(locale) ? getCurrentEffect(itemA, pathname) : true;
                        return (
                            <Fragment key={index}>
                                {isOpen_QUESTIONNAIRE && isOpenInPathname && (
                                    <WidgetsItemQuestionnaire
                                        iconUrl={itemA.widgetIcon}
                                        show={show}
                                        hide={hide}
                                        effectUser={itemA.effectUser}
                                        startTime={globalTimestamp}
                                        hasContinue={hasContinue}
                                        closeOnlyMode={questionnaireCloseOnlyMode}
                                        setCloseOnlyMode={setQuestionnaireCloseOnlyMode}
                                    />
                                )}
                                {isOpen_MicrosoftChatItemA && isOpenInPathname && !isOpenBottomChat && (
                                    <>
                                        <WidgetsItemMicrosoftChat position="right" microsoftChatItemA={itemA} rightIconUrl={itemA.widgetIcon} />
                                    </>
                                )}
                                {isOpen_SHOPPING_CART && (
                                    <>
                                        <div className={`WidgetsItem WidgetsItem-GloCart 22 ${showEcoCart ? 'show' : 'hide'}`}>
                                            <EcoCartIcon url={itemA.widgetIcon || ''} callback={setShowEcoCart} />
                                        </div>
                                    </>
                                )}
                                {isOpen_MEMBER && isOpenInPathname && (
                                    <>
                                        <WidgetsItemEcoCreditsWin iconUrl={itemA.widgetIcon} />
                                    </>
                                )}
                            </Fragment>
                        );
                    })}
                </div>
            </div>
            <EcoCart />
            <EcoCreditsWinEnterA />
            {/* 页面存在问卷挂件，则显示问卷弹窗 */}
            {openNewWidgetsLocales.includes(locale as 'us') && __globar_right_list.some((item: any) => item.widgetType === 'QUESTIONNAIRE') && (
                <QuestionnaireModalDynamic
                    open={open}
                    show={show}
                    hide={hide}
                    immediatelyHide={immediatelyHideQuestionnaire}
                    hasContinue={hasContinue}
                    setHasContinue={setHasContinue}
                    modalPos={modalPos}
                    closeOnlyMode={questionnaireCloseOnlyMode}
                />
            )}
            {showHiddenBtn && <WidgetsArrowSvgA />}
        </section>
    );
}
